import { BqDivider } from '@beeq/react'
import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 800px) {
    width: 350px;
  }
`

export const HeaderCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: ${(props) => props.$width + 'px'};
  padding: ${(props) => (props.$isSortIcon ? '14px' : '17px') + ' var(--bq-spacing-m)'};
  font-size: var(--bq-font-size--xs);
  font-weight: var(--bq-font-weight--bold);
`

export const HeaderColumnDivider = styled.div`
  height: 12px;
  width: 1px;
  background-color: var(--bq-background--secondary);
`

export const HeaderDivider = styled(BqDivider)`
  @media screen and (max-width: 800px) {
    width: 350px;
  }
`
